import Model from '../orm/Model'

export default class UserStudent extends Model {
    
    static entity = 'user_student'
  
    static primaryKey = ['user_id', 'student_id']
  
    static fields () {
        return {
            user_id: this.attr(null),
            student_id: this.attr(null)
        }
    }
}